import { useEffect } from "react";
import { FACEBOOK_APP_ID } from "src/constants/socialPlatformAppId";

const FacebookSDKLoader = () => {
    useEffect(() => {
        const appId = FACEBOOK_APP_ID;

        const script = document.createElement("script");
        script.src = "https://connect.facebook.net/en_US/sdk.js";
        script.async = true;
        script.onload = () => {
            window.FB.init({
                appId: appId,
                cookie: true,
                xfbml: true,
                version: "v21.0",
            });
        };

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return null;
};

export default FacebookSDKLoader;
